import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CreditOrderReportData} from "./credit-order-report.data";

@Injectable()
export class CreditOrderReportModel extends ReportModel<CreditOrderReportData> {
    constructor(injector: Injector) {
        super(injector, CreditOrderReportData)
    }
}
